@if (showStartPicker || showEndPicker) {
  <div
    class="tw-fixed tw-inset-0 tw-bg-black tw-opacity-50 tw-z-10"
    (click)="togglePickersVisibility(PICKER_TYPE.BOTH)"
  ></div>
}
<div class="tw-w-full tw-h-12 tw-flex tw-gap-2 tw-items-center" [appScrollLock]="isPickerOpen">
  <div
    class="tw-w-full tw-h-full tw-relative tw-bg-dt-surface-card left-round-border"
    [ngClass]="showStartPicker ? 'tw-z-20' : ''"
  >
    <div
      #startPickerTrigger
      class="tw-w-full tw-h-full left-round-border tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-6 xs:tw-px-4 tw-shadow-modal-strong hover:tw-bg-dt-surface-elevated tw-cursor-pointer border-gradient-neuomorphic hover-border-past"
      [ngClass]="{
        'tw-bg-dt-surface-elevated border-active-past !tw-shadow-none': showStartPicker,
      }"
      (click)="togglePickersVisibility(PICKER_TYPE.START)"
      appKeyboardActivatable
      aria-haspopup="dialog"
      [appKeyboardActivatableExpanded]="showStartPicker"
      (appKeyboardActivatableActivate)="togglePickersVisibility(PICKER_TYPE.START)"
    >
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-gap-2 xs:tw-flex-col xs:tw-gap-0">
          <span class="tw-text-xs">From</span>
          <span class="tw-text-[13px]">{{ displayDateText().startDate }}</span>
        </div>
      </div>
    </div>
    <app-calendar
      #startPicker
      role="dialog"
      [attr.aria-label]="'startDate' | i18n"
      *ngIf="showStartPicker"
      [pickerType]="'start'"
      [dateRange]="initialDateRange()"
      [originalDateRange]="resetOriginalDateRange()"
      [timeDirectionOptions]="[AGO]"
      [currentDateFilter]="getStartDateFilter()"
      (dateChangeEvent)="onDateChange($event, 'startDate')"
      (dateRangePreviewEvent)="onDatePreview($event)"
      (confirmEvent)="onStartPickerConfirm()"
      (cancelEvent)="onPickerCancel()"
      class="date-picker past"
      [ngStyle]="
        isMobileScreen()
          ? {
              transform: 'translateX(' + startPickerTranslateValue + ')',
            }
          : {}
      "
    ></app-calendar>
  </div>

  <div
    class="tw-w-full tw-h-full tw-relative tw-bg-dt-surface-card right-round-border"
    [ngClass]="showEndPicker ? 'tw-z-20' : ''"
  >
    <div
      #endPickerTrigger
      class="tw-w-full tw-h-full right-round-border tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-6 xs:tw-px-4 tw-shadow-modal-strong hover:tw-bg-dt-surface-elevated tw-cursor-pointer border-gradient-neuomorphic hover-border-past"
      [ngClass]="{
        'tw-bg-dt-surface-elevated border-active-past !tw-shadow-none': showEndPicker,
      }"
      (click)="togglePickersVisibility(PICKER_TYPE.END)"
      appKeyboardActivatable
      aria-haspopup="dialog"
      [appKeyboardActivatableExpanded]="showEndPicker"
      (appKeyboardActivatableActivate)="togglePickersVisibility(PICKER_TYPE.END)"
    >
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-gap-2 xs:tw-flex-col xs:tw-gap-0">
          <span class="tw-text-xs">To</span>
          <span class="tw-text-[13px]">{{ displayDateText().endDate }}</span>
        </div>
        <icon name="calendar" [size]="6" [currentColor]="'color-icon-default'"></icon>
      </div>
    </div>
    <app-calendar
      #endPicker
      role="dialog"
      [attr.aria-label]="'endDate' | i18n"
      *ngIf="showEndPicker"
      [pickerType]="'end'"
      [dateRange]="initialDateRange()"
      [originalDateRange]="resetOriginalDateRange()"
      [timeDirectionOptions]="[AGO]"
      [currentDateFilter]="getEndDateFilter()"
      (dateChangeEvent)="onDateChange($event, 'endDate')"
      (dateRangePreviewEvent)="onDatePreview($event)"
      (confirmEvent)="onEndPickerConfirm()"
      (cancelEvent)="onPickerCancel()"
      class="date-picker tw-right-0 xs:tw-right-auto past"
      [ngStyle]="
        isMobileScreen()
          ? {
              transform: 'translateX(' + endPickerTranslateValue + ')',
            }
          : {}
      "
    ></app-calendar>
  </div>
</div>
